import { T } from "components/util/t";
import { StatusPill } from "../StatusPill";

const statusLabels = { "denied": "cancelled" };

export const EntryStatusPill = ({ children, ...rest }) => <StatusPill {...rest}><T>{statusLabels[children] || children}</T></StatusPill>;
